import { ShoppingBag } from "lucide-react";
import { useCart } from "@/hooks/useCart";
import { useHydrated } from "@/hooks/useHydrated";
import { useAppTranslation } from "@/i18n/useAppTranslation";

/** Header cart: always on the store pages, elsewhere only once something is in it. */
export function CartButton({ onStorePage }: { onStorePage: boolean }) {
  const cart = useCart();
  const hydrated = useHydrated();
  const { t } = useAppTranslation("resourcesPage");
  const count = hydrated ? cart.count : 0;

  if (!onStorePage && count === 0) return null;

  return (
    <button
      type="button"
      onClick={cart.open}
      aria-label={count ? t("cartOpenWithCount", { count }) : t("cartOpen")}
      className="relative grid size-11 place-items-center rounded-full text-brand-primary transition-colors hover:bg-teal-soft"
    >
      <ShoppingBag className="size-5.5" strokeWidth={1.75} aria-hidden="true" />
      {count ? (
        <span
          aria-hidden="true"
          className="absolute right-0.5 top-0.5 grid min-w-5 place-items-center rounded-full bg-brand-primary px-1 text-xs font-semibold leading-5 text-white ring-2 ring-white"
        >
          {count}
        </span>
      ) : null}
    </button>
  );
}
